import { useMediaQuery } from '@material-ui/core';
import { CustomTheme } from '@nemuru-eng/js-api-client';
import { generatePath } from 'react-router-dom';

import { articleTypeFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/articleTypeFieldColumn';
import { channelAgentNameFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/channelAgentNameFieldColumn';
import { documentNumberFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/documentNumberFieldColumn';
import { lenderLogoFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/lenderLogoFieldColumn';
import { orderMerchantReferenceFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/orderMerchantReferenceFieldColumn';
import { toDealDetailFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/toDealDetailFieldColumn';
import { updatedAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/updatedAtFieldColumn';
import { borrowerNameFieldColumn } from '@/components/modules/OrderList/constants/OrderDataGridFields/components/borrowerNameFieldColumn';
import { orderPrincipalFieldColumn } from '@/components/modules/OrderList/constants/OrderDataGridFields/components/orderPrincipalFieldColumn';
import { orderStatusFieldColumn } from '@/components/modules/OrderList/constants/OrderDataGridFields/components/orderStatusFieldColumn';
import { orderStatusValueWithPrincipalAmountMobileFieldColumn } from '@/components/modules/OrderList/constants/OrderDataGridFields/components/orderStatusValueWithPrincipalAmountMobileFieldColumn';
import { updatedAtWithBorrowerAndMerchantNameMobileFieldColumn } from '@/components/modules/OrderList/constants/OrderDataGridFields/components/updatedAtWithBorrowerAndMerchantNameMobileFieldColumn';
import { DETAILS_PATH_BY_PRODUCT } from '@/config/config';
import { ApplicationType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface OrderDataGridFieldsProps {
  applicationType: ApplicationType;
  reducedWidth?: boolean;
}

export function OrderDataGridFields({ applicationType, reducedWidth = false }: OrderDataGridFieldsProps) {
  const { breakpoints, themeName } = useCustomTheme();

  const showEntityColumn = themeName !== CustomTheme.CAIXABANK;

  const isDownMd = useMediaQuery(breakpoints.down('md'));
  const targetPath = DETAILS_PATH_BY_PRODUCT[applicationType];
  const linkTo = (id) => generatePath(targetPath, { loanId: id });
  const borrowerOnlineFields = {
    desktop: [
      articleTypeFieldColumn({ flex: 0.05 }),
      borrowerNameFieldColumn({ flex: 0.13 }),
      ...(reducedWidth
        ? []
        : [
            channelAgentNameFieldColumn({ flex: 0.13 }),
            showEntityColumn ? lenderLogoFieldColumn({ flex: 0.1 }) : documentNumberFieldColumn({ flex: 0.12 }),
          ]),
      orderMerchantReferenceFieldColumn({ flex: 0.15 }),
      orderPrincipalFieldColumn({ flex: 0.14 }),
      updatedAtFieldColumn({ flex: 0.12 }),
      orderStatusFieldColumn({ flex: 0.14 }),
      toDealDetailFieldColumn({ linkTo, flex: 0.06 }),
    ],
    mobile: [
      updatedAtWithBorrowerAndMerchantNameMobileFieldColumn({ flex: 0.58 }),
      orderStatusValueWithPrincipalAmountMobileFieldColumn({ flex: 0.42 }),
    ],
  };

  const DataGridFields = {
    [ApplicationType.ORDER]: borrowerOnlineFields.desktop,
    [ApplicationType.PAY_BY_LINK]: borrowerOnlineFields.desktop,
  };

  const MobileDataGridFields = {
    [ApplicationType.ORDER]: borrowerOnlineFields.mobile,
    [ApplicationType.PAY_BY_LINK]: borrowerOnlineFields.mobile,
  };

  return isDownMd ? MobileDataGridFields[applicationType] : DataGridFields[applicationType];
}
